import { Box } from '@mui/material';

import DynamicForm, { DynamicFormProps } from './DynamicForm';

const containerStyles = {
	'& .tag__dynamic-form__inputs > .tag__dynamic-form__input-row': {
		'& .tag__dynamic-form__message': {
			display: 'block',
			textAlign: 'center',
			'& .tag__dynamic-form__message-title': {
				fontSize: '1.75rem',
				lineHeight: '2.25rem',
			},
			'& .tag__dynamic-form__message-copy': {
				fontSize: '1.25rem',
			},
		},
		'& .tag__dynamic-form__field-error': {
			fontWeight: '200',
		},
	},
	'& .tag__dynamic-form__checkbox': {
		display: 'flex',
		alignSelf: 'flex-start',
	},
};

export default function ZenotiWrapper(props: Readonly<DynamicFormProps>) {
	return (
		<Box id="zenoti-wrapper" sx={containerStyles}>
			<DynamicForm {...props} />
		</Box>
	);
}
